export default "__VITE_ASSET__09af32b2__"